import { inject, Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { isDefined } from '@techniek-team/rxjs';
import { Observable, shareReplay, take } from 'rxjs';
import { usersActions } from './+state/users.actions';
import { UsersSelectors } from './+state/users.selectors';

@Injectable()
export class UsersStoreService {
  private readonly store = inject(Store);
  public loading$: Observable<boolean> = this.store.pipe(select(UsersSelectors.loading));

  public loaded$: Observable<boolean> = this.store.pipe(select(UsersSelectors.loaded));

  public user$ = this.store.pipe(select(UsersSelectors.activeUser)).pipe(isDefined());

  public whenUserExists$ = this.store
    .pipe(select(UsersSelectors.activeUser))
    .pipe(isDefined(), take(1), shareReplay(1));

  public readonly user = this.store.selectSignal(UsersSelectors.activeUser);

  public readonly isSchedulingTeam = this.store.selectSignal(UsersSelectors.isSchedulingTeam);

  public readonly isLocationManager = this.store.selectSignal(UsersSelectors.isLocationManager);

  public readonly isAdmin = this.store.selectSignal(UsersSelectors.isAdmin);

  public init(): void {
    this.store.dispatch(usersActions.initUser());
  }
}
